import image1 from '../../assets/c7.PNG'
import image2 from '../../assets/c2.PNG'
import {AiOutlineInstagram, AiOutlineFacebook, AiOutlineTwitter} from 'react-icons/ai'
const data = [
    {id: 1,
     image: image2,
     name: '66cm PhotoBooth',
     desc: 'Only Carries Two (2) ',
     add:'Persons at a time',
     price: '80,000.00  per 6 hours',
     instagram: AiOutlineInstagram,
     facebook: AiOutlineFacebook,
     twitter: AiOutlineTwitter
    }, 
    
    {id: 2,
        image: image1,
        name: '115cm PhotoBooth',
        desc: 'Only Carries not more ',
        add: 'than Seven (7) Persons at a time',
        price: '100,000.00 per 6 hours',
        instagram: AiOutlineInstagram,
     facebook: AiOutlineFacebook,
     twitter: AiOutlineTwitter
       }, 
      

]

export default data;